import React from "react";
import { motion } from "framer-motion";
import "./nav.css";

export default function Nav() {
  const links = ["home", "about", "skills", "contact"];

  return (
    <motion.nav
      className="nav"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="nav-brand">Emil<span className="dot">.</span></div>
      <ul>
        {links.map((link) => (
          <li key={link}>
            <a href={`#${link}`}>{link.charAt(0).toUpperCase() + link.slice(1)}</a>
          </li>
        ))}
      </ul>
    </motion.nav>
  );
}